import script from "./Swiper.vue?vue&type=script&setup=true&lang=js"
export * from "./Swiper.vue?vue&type=script&setup=true&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=f489c62e&lang=scss"
import "./Swiper.vue?vue&type=style&index=1&id=f489c62e&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f489c62e"]])

export default __exports__